import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import moment from 'moment';
import DefaultUserPhoto from '../../../util/DefaultUserPhoto/DefaultUserPhoto';
import { addElipsesAfterLength } from '../../../../util/util';

import dashboardStyles from '../Dashboard.module.scss';
import styles from './Feed.module.scss';
import { showModal } from 'legacy/actions/modalActions';
import { showQuickView } from '../../../../util/modalFlows';
import { logEvent } from 'legacy/common/utils/amplitude';
import {
  EVENT_CLICK_INVITE,
  EVENT_CLICK_PROFILE_FROM_FEED
} from 'legacy/common/constants/events';

const GoingToEvent = ({ ticket, self, router }: { ticket: any; self: any; router: any }) => {
  const { t } = useTranslation('dashboard');
  return (
    <div key={ticket._id} className={styles.attendingEvent}>
      <div className={styles.fromNow}>{moment(ticket.createdAt).fromNow()}</div>
      <div className="pic-wrapper">
        <div
          onClick={() => {
            if (ticket.user._id !== self._id) {
              logEvent(EVENT_CLICK_PROFILE_FROM_FEED, {
                url: router.pathname
              });
            }
            showQuickView(ticket.user._id, self._id, router);
          }}
          className="pic"
        >
          {ticket.user.photo ? (
            <img src={ticket.user.photo.url} alt={ticket.user.firstName} />
          ) : (
            <DefaultUserPhoto style={{ fontSize: '10px' }} />
          )}
        </div>
      </div>
      <div className="details">
        <p>
          <a
            onClick={() => {
              if (ticket.user._id !== self._id) {
                logEvent(EVENT_CLICK_PROFILE_FROM_FEED, {
                  url: router.pathname
                });
              }
              showQuickView(ticket.user._id, self._id, router);
            }}
            className={styles.underline}
          >
            {ticket.user.firstName}
          </a>{' '}
          {t('feed.isGoingTo')}
          <br />
          <Link
            className={styles.underline}
            href={`/events/${ticket.event._id}`}
            legacyBehavior
          >
            {addElipsesAfterLength(ticket.event.title, 25)}
          </Link>
        </p>
      </div>
    </div>
  );
};

const FeedTransaction = ({ transaction, self, router }: { transaction: any; self: any; router: any }) => {
  const { t } = useTranslation('dashboard');
  return (
    <div key={transaction._id} className={styles.transaction}>
      <div className={styles.fromNow}>
        {moment(transaction.createdAt).fromNow()}
      </div>
      <div className="pic-wrapper">
        <div
          onClick={() => {
            if (transaction.user._id !== self._id) {
              logEvent(EVENT_CLICK_PROFILE_FROM_FEED, {
                url: router.pathname
              });
            }
            showQuickView(transaction.user._id, self._id, router);
          }}
          className="pic"
        >
          {transaction.user.photo ? (
            <img
              src={transaction.user.photo.url}
              alt={transaction.user.firstName}
            />
          ) : (
            <DefaultUserPhoto style={{ fontSize: '10px' }} />
          )}
        </div>
      </div>

      <div className="details">
        <p>
          <a
            onClick={() => {
              if (transaction.user._id !== self._id) {
                logEvent(EVENT_CLICK_PROFILE_FROM_FEED, {
                  url: router.pathname
                });
              }
              showQuickView(transaction.user._id, self._id, router);
            }}
            className={styles.underline}
          >
            {transaction.user.firstName}
          </a>
          {t('feed.bounced')}
          <a
            onClick={() => {
              if (transaction.receiver._id === self._id) {
                logEvent(EVENT_CLICK_PROFILE_FROM_FEED, {
                  url: router.pathname
                });
              }
              showQuickView(transaction.receiver._id, self._id, router);
            }}
            className={styles.underline}
          >
            {transaction.receiver.firstName}
          </a>
          <strong>{` $${transaction.amount}`}</strong>
          {transaction.reason ? ` for ${transaction.reason}` : ''}
        </p>
      </div>
    </div>
  );
};

const Feed = ({ newsFeed, device, self, showModal }: { newsFeed: any[]; device: string; self: any; showModal: (modalType: string) => void }) => {
  const router = useRouter();
  const { t } = useTranslation('dashboard');

  const feed = newsFeed.map((item) => (
    <div key={item._id} className={styles.feedItem}>
      {item.type === 'event' && (
        <GoingToEvent
          ticket={item}
          self={self}
          router={router}
        />
      )}
      {item.type === 'p2p' && (
        <FeedTransaction transaction={item} self={self} router={router} />
      )}
    </div>
  ));

  return (
    <div className={classnames('bn-container', [styles.Feed], device)}>
      <div className={dashboardStyles.cardHeader}>
        <span className={dashboardStyles.cardTitle}>{t('feed.title')}</span>
      </div>
      <div className="content">
        <div className="section newsfeed">
          {feed}
          <div className={styles.inviteFriends}>
            <img
              id="balloons"
              src="/img/illustrations/inviteBalloons.svg"
              alt=""
            />
            <div className="invite-content">
              <p>{t('feed.inviteFriends')}</p>
              <div
                className="bn-btn primary"
                onClick={() => {
                  logEvent(EVENT_CLICK_INVITE, {
                    url: router.pathname
                  });
                  showModal('INVITE_TO_BOUNCE');
                }}
              >
                {t('feed.invite')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  self: state.user.user
});

export default connect(mapStateToProps, { showModal })(Feed);
